import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/getbiz_website/getbiz_website/components/accordions/FaqWithButton.jsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/getbiz_website/getbiz_website/components/common/ParallaxContainer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/getbiz_website/getbiz_website/components/gitbiz/Pricing.jsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/getbiz_website/getbiz_website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/getbiz_website/getbiz_website/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/getbiz_website/getbiz_website/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/getbiz_website/getbiz_website/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
